import { toggleCookieHubWheel } from 'utility/cookie-hub-wheel'

const subListTriggerClasses = [
  '.mobile-menu .category-card:not([data-default])',
  '.mobile-menu__button[data-trigger="true"]',
  '.mobile-menu__arrow--right',
  '.mobile-menu__button--logged-in',
].join(', ')

const el = {
  trigger: document.querySelector<HTMLButtonElement>('.header__burger'),
  mobileMenu: document.querySelector<HTMLDivElement>('.mobile-menu'),
  overlay: document.querySelector<HTMLDivElement>('.overlay'),
  sideCart: document.querySelector<HTMLDivElement>('.side-cart'),
  sideExtension: document.querySelector<HTMLDivElement>('.side-extension'),
  cartRecycle: document.querySelector<HTMLDivElement>('.cart-recycle'),
  subListTriggers: document.querySelectorAll<HTMLAnchorElement>(subListTriggerClasses),
  backLinks: document.querySelectorAll<HTMLAnchorElement>('.mobile-menu__link--header'),
}

export const MobileMenu = {
  init: () => {
    if (!el.mobileMenu || !el.trigger) return
    el.trigger.addEventListener('click', MobileMenu.toggleMenu)
    window.addEventListener('resize', MobileMenu.onResize)
    if (el.overlay) el.overlay.addEventListener('click', MobileMenu.closeMenu)
    el.subListTriggers.forEach((target) =>
      target.addEventListener('click', MobileMenu.onSubListTriggerClick)
    )
    el.backLinks.forEach((target) =>
      target.addEventListener('click', MobileMenu.onBackLinkClick)
    )
  },

  openMenu: () => {
    el.mobileMenu.classList.add('mobile-menu--open')
    el.trigger.classList.add('burger--open')
    document.body.classList.add('h-disable-scroll')

    if (el.overlay) el.overlay.classList.add('overlay--visible')
    if (el.sideCart) el.sideCart.classList.remove('side-cart--open')
    if (el.sideExtension) el.sideExtension.classList.remove('side-extension--open')
    if (el.cartRecycle) el.cartRecycle.classList.remove('cart-recycle--open')
    toggleCookieHubWheel({ hide: true })
  },

  closeMenu: () => {
    el.mobileMenu.classList.remove('mobile-menu--open')
    el.trigger.classList.remove('burger--open')
    document.body.classList.remove('h-disable-scroll')
    if (el.overlay) el.overlay.classList.remove('overlay--visible')
    toggleCookieHubWheel({ hide: false })
  },

  toggleMenu: () => {
    if (el.trigger.classList.contains('burger--open')) {
      MobileMenu.closeMenu()
      return
    }
    MobileMenu.openMenu()
  },

  onResize: () => {
    const { innerWidth } = window
    if (innerWidth >= 1300) {
      if (el.mobileMenu && el.mobileMenu.classList.contains('mobile-menu--open')) {
        MobileMenu.closeMenu()
      }
    }
  },

  onSubListTriggerClick: (e: Event & { target: HTMLAnchorElement }) => {
    e.preventDefault()

    let subList = e.target.nextElementSibling
    if (e.target.classList.contains('category-card__content')) {
      subList = e.target.parentElement.nextElementSibling
    }

    if (!subList || !subList.classList.contains('mobile-menu__sub-list')) return
    subList.classList.add('mobile-menu__sub-list--active')
  },

  onBackLinkClick: (e: Event & { target: HTMLAnchorElement }) => {
    e.preventDefault()
    const subList = e.target?.parentElement?.parentElement
    if (!subList || !subList.classList.contains('mobile-menu__sub-list')) return
    subList.classList.remove('mobile-menu__sub-list--active')
  },
}
